// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Images
import mpesaLogo from "assets/images/logos/m-pesa.png";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

function PaymentMethod({ phone }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      borderRadius="lg"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={3}
      sx={{
        border: ({ borders: { borderWidth, borderColor } }) =>
          `${borderWidth[1]} solid ${borderColor}`,
      }}
    >
      <MDBox
        component="img"
        src={mpesaLogo}
        alt="mpesa logo"
        width="30%"
        mr={2}
      />
      <MDTypography variant="h6" fontWeight="medium">
        {phone}
      </MDTypography>
      <MDBox
        ml="auto"
        lineHeight={0}
        color={darkMode ? "white" : "dark"}
      ></MDBox>
    </MDBox>
  );
}

export default PaymentMethod;
